import { Customer } from 'types/user';
import * as yup from 'yup';

export const getInitialValues = (customer: Customer | null) => ({
  companyName: customer?.companyName || '',
  type: customer?.type || '',
  washHub: '',
  site: customer?.site || '',
  billingContact: customer?.billingContact || '',
  collectionPoint: customer?.collectionPoint || '',
});

export const validationSchema = yup.object().shape({
  companyName: yup.string().required('Company Name is a required field'),
  type: yup.string(),
  billingContact: yup.string(),
});
